import { useRef, useEffect } from 'react';

import {
  ModalContent,
  ModalBackground,
  ModalContentWithBorderTop,
} from './styles';

interface IModalProps extends React.HTMLAttributes<HTMLDivElement> {
  borderTop?: boolean | null;
  onClickOutside?: () => void;
  // dialog: card sem borda superior, raio 8 e sombra (janelas de escolha e confirmação).
  variant?: 'mobile-rc' | 'dialog';
}

export const ModalWindow = ({
  onClickOutside, borderTop, ...props
}: IModalProps): JSX.Element => {
  const refModal = useRef<any>(null);
  // O listener é registrado uma vez; a ref guarda o callback do último render, para que trocar o
  // conteúdo da janela (ex.: escolha → confirmação) também troque a ação do clique fora.
  const onClickOutsideRef = useRef(onClickOutside);
  onClickOutsideRef.current = onClickOutside;

  useEffect(() => {
    function handleClickOutside(event) {
      if (onClickOutsideRef.current && refModal.current && !refModal.current.contains(event.target) && !event.target.closest('.select-search__select')) {
        onClickOutsideRef.current();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <ModalBackground>
      {borderTop ? <ModalContentWithBorderTop ref={refModal} {...props} /> : <ModalContent ref={refModal} {...props} />}
    </ModalBackground>
  );
};
